var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-box"},[_c('iframe',{attrs:{"id":"iframe-l","src":_vm.src,"frameborder":"0","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }